import i18next from 'i18next'

i18next.addResourceBundle('en', 'system', {
    core: 'Core',
    dispatching_validation: 'Dispatching Validation',
    verify_on_edit: 'Verify on Edit',
    testing: 'Testing',
    thread_number_for_tests: 'Thread Number for Tests',
    reset_settings: 'Reset Settings',
    restore_defaults_warning: '<0>WARNING!</0> If you click this button, all settings will be restored to default values. All user defined values, such as repository settings, will be lost. Use this button only if you understand the consequences.',
    restore_defaults_and_restart: 'Restore Defaults and Restart',
    history: 'History',
    maximum_count_of_changes: 'The maximum count of saved changes for each project per user',
    clear_all_history: 'Clear All History',
    other: 'Other',
    database_configuration: 'Database Configuration',
    database_configuration_info: 'Set up a database to be used for managing users in OpenL Studio. Please contact your System Administrator for this information if necessary.',
    update_table_properties: 'Update table properties (\'createdOn\', \'modifiedBy\' etc.) on editing',
    date_format: 'Date Format',
    time_format: 'Time Format',
    db_url: 'Database URL',
    login: 'Login',
    password: 'Password',
    maximum_pool_size: 'Maximum Pool Size',
    confirm_delete_all_history: 'Are you sure you want to delete all history?',
    confirm_delete_all_history_message: 'Do you really want to clear all local changes between revisions for all users and all projects?',
    delete_all_history_success: 'All history was deleted successfully',
    confirm_apply_settings: 'Are you sure you want to apply the settings?',
    confirm_apply_settings_message: 'All users working with OpenL Studio now will lose all unsaved changes. Are you sure you want to apply these settings now?',
    confirm_restore_defaults: 'Are you sure you want to restore defaults?',
    confirm_restore_defaults_message: 'All users working with OpenL Studio now will lose all unsaved changes. Are you sure you want to restore defaults now?',
})
